
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';
import { CourseFormData } from './types';

export const useAddCourse = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: CourseFormData) => {
      console.log('Adding course with data:', data);
      
      const { data: result, error } = await supabase
        .rpc('add_course_offering', {
          course_name: data.course_name,
          course_type: data.course_type,
          language: data.language,
          duration_hours: data.duration_hours,
          price: data.price,
          original_price: data.original_price,
          state_fee: data.state_fee || null,
          description: data.description || null,
          benefits: data.benefits || null,
          footer_text: data.footer_text || null,
          // Note: state parameter removed as it's not in the TypeScript definition
        });
      
      if (error) {
        console.error('Error adding course:', error);
        throw error;
      }
      
      console.log('Course added successfully:', result);
      return result;
    },
    onSuccess: () => {
      toast.success('Course added successfully');
      queryClient.invalidateQueries({ queryKey: ['courses'] });
    },
    onError: (error) => {
      console.error('Error in useAddCourse:', error);
      toast.error('Failed to add course', {
        description: error instanceof Error ? error.message : 'Unknown error'
      });
    },
  });
};
